import {normalizeArrayOfObjectsIntoSingleObject} from "../../../utils/arrayUtils";
import dayjs from "dayjs";

export const alarmSystemAnalysisExcelProcess = (data)=> {
    return data?.map(item => {
        return {
            serialNumber: item?.serialNumber,
            ...normalizeArrayOfObjectsIntoSingleObject(item?.alarmCountByTypes),
        }
    });
};

export const genericSystemAnalysisExcelProcess = (data)=> {
    // in the event where no processing is needed
    data = data?.map(item => {
        const d = dayjs(item.data);
        return {
            ...item,
            data: d.isValid() ? d.format("DD/MM/YYYY h:mm:ss a") : item.data ? item.data : "N/A",
        };
    });

    return data;
};

export const consumptionSystemAnalysisExcelProcess = (data)=> {};

export const flowSystemAnalysisExcelProcess = (data)=> {};

